<template>
    <div class="">
         <b-loading :is-full-page="true" v-model="isFullScreenSearching" :can-cancel="true"></b-loading>

         <section class="hero is-info mb-5">
				<div class="hero-body">
					<div class="container">
						<h1 class="title">Member Pathology</h1>
						<h2 class="subtitle">Member Pathology</h2>
					</div>
				</div>
		</section>   
        <section  class="mr-5 ml-5 mt-3" >
        
                    <nav class="level">
                                <div class="level-left">
                                    
                                    <div class="level-item">
                                                <b-input placeholder="Search..."
                                                        type="search"
                                                        icon="magnify"
                                                        icon-clickable
                                                        @keyup.native.enter="searchMember" 
                                                        v-model="searchTxt"
                                                        >
                                                </b-input>
                                    </div>
                                    <div class="level-item">
                                        <b-button type="is-info" icon-left="magnify" @click="searchMember"></b-button>
                                    </div>

                                    


                                


                                </div>
            
                                <div class="level-right ">
                                    <div class="level-item">
                                        <b-button type="is-info" 
                                                  icon-left="plus"
                                                  @click="addMemberPatho">Add New Member</b-button>
                                    </div>
                                </div>
                            
                            </nav>





                    <!-- search result  -->
                    <b-table
                            :data= "isEmpty ? []  : memberResultSearch"
                            bordered
                            striped
                            hoverable

                    >   <b-table-column   label="Member ID" width="10%" centered v-slot="props">
                             
                             

                               <b-tooltip position="is-top" multilined type="is-danger is-light">
                                    <b-button type="is-danger is-light" 
                                     icon-left="pencil"
                                     @click="editMemberPatho( props.row)">{{ props.row.member_id }}</b-button>

                                     
                                    <template v-slot:content>
                                      แก้ไข  <b> {{ props.row.name }} </b> <br/> <i> {{ props.row.member_id }}</i>.
                                    </template>
                                </b-tooltip>

                        </b-table-column>
                        <b-table-column   label="ชื่อ"   v-slot="props">
                            {{ props.row.name }}
                        </b-table-column>

                        <b-table-column   label="บ้านเลขที่"   v-slot="props">
                            {{ props.row.house_address }}
                        </b-table-column>

                        <b-table-column   label="ที่อยู่"   v-slot="props">
                            {{ props.row.address_txt }}  {{ props.row.tumbon_txt }} {{ props.row.ampur_txt }} {{ props.row.province_txt }} 
                        </b-table-column>

                        <b-table-column   label="โทรศัพท์"   v-slot="props">
                            {{ props.row.phone1 }}
                        </b-table-column>

                        <b-table-column   label="Card ID"   v-slot="props">
                            {{ props.row.card_id }}
                        </b-table-column>


                        <b-table-column   label="Tax ID"   v-slot="props">
                            {{ props.row.tax_id }}
                        </b-table-column>



                        <!-- <b-table-column  label="#" width="10%" centered  v-slot="props">
                           <b-button type="is-danger is-light" 
                                     icon-left="pencil"
                                     @click="editMemberPatho( props.row)">Edit</b-button>
                        </b-table-column> -->


                        <template slot="empty">
                            <section class="section">
                                <div class="content has-text-grey has-text-centered">
                                    <p>
                                        <b-icon
                                                icon="table-search"
                                                size="is-large">
                                        </b-icon>
                                    </p>
                                    <p>Nothing here.</p>
                                </div>
                            </section>
                        </template>



                    </b-table>
        </section>   
         
         
         <b-modal
                v-if="isAddEditMemberPathoShowing"
                v-model="isAddEditMemberPathoShowing"
                has-modal-card
                 full-screen
                :can-cancel="true">
             <AddEditMemberPatho
                     v-if="isAddEditMemberPathoShowing"
                     :isShowing="isAddEditMemberPathoShowing"
                     :dataToChild="dataToChild_AddEditMemberPatho"
                     :mode="mode_AddEditMemberPatho"
                     @close="closeAddEditMemberPatho"
                     @closeWithUpdate="closeAddEditMemberPatho_WithUpdate"
             />
        </b-modal>
 
    </div>
</template>


<script>
import { getBaseURLforBackEnd , getConfigAxios    } from '@/utils.js'
import axios from "axios"
import { mapState , mapActions  } from "vuex";
import AddEditMemberPatho from  '../PathoMember/AddEditMemberPatho.vue'

export default {
    name : "PathoMemberDashboard",
    components:{
        AddEditMemberPatho,
    },
    mounted(){
               this.checkAndLoadProvinceAmpurTumbonData()
    },
    computed:{
            ...mapState({
                access_token: state => state.master_data.access_token ,

                province: state => state.master_data.province ,
                ampur: state => state.master_data.ampur ,
                tumbon: state => state.master_data.tumbon ,


            }) ,


    },
    methods:{
        ...mapActions({
             fetchProvince: 'master_data/fetchProvince',
             fetchAmpur: 'master_data/fetchAmpur',
             fetchTumbon: 'master_data/fetchTumbon',
        }),
       async checkAndLoadProvinceAmpurTumbonData(){
              this.isFullScreenSearching = true 
              if(this.province.length==0){
               await       this.fetchProvince()  
              }
              if(this.ampur.length==0){
               await       this.fetchAmpur()  
              }
              if(this.tumbon.length==0){
               await       this.fetchTumbon()  
              }
              this.isFullScreenSearching = false
        }, 
        closeAddEditMemberPatho(){
             this.isAddEditMemberPathoShowing = false
        },
        closeAddEditMemberPatho_WithUpdate(){
             this.isAddEditMemberPathoShowing = false
             if(this.searchTxt.length>=3){
               this.searchMember() // force refresh 
             }
             
        },



        addMemberPatho(){
            this.dataToChild_AddEditMemberPatho = Object.assign({},{ 
                "id": 1, 
                "name": "", 
                "enabled": true, 
                "member_id": "", 
                "house_address": "", 
                "address_txt": "", 
                "phone1": "", 
                "tumbon_p": "",
                "card_id": null,
                "tax_id": null                
            })
            this.mode_AddEditMemberPatho = 0
            this.isAddEditMemberPathoShowing = true

        },
        editMemberPatho(_data){
            this.dataToChild_AddEditMemberPatho = Object.assign({},_data)
            this.mode_AddEditMemberPatho = 1
            this.isAddEditMemberPathoShowing = true
        },




        searchMember(){
                
                const datTo ={
                      "txt_search" : this.searchTxt
                }
                this.isFullScreenSearching = true 
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/searchofmemberpatho`,datTo,getConfigAxios())
                   .then((res)=>{
                        this.memberResultSearch = res.data
                        this.isFullScreenSearching = false 
                   })
                   .catch((err)=>{
                          this.isFullScreenSearching = false 
                          this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.response.data.msg}<br/>  ${err.message}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle-outline',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                         })
                   })
                

        }
    },
    data(){
        return {
             isFullScreenSearching : false ,
             memberResultSearch : [],
             isEmpty : false,

             searchTxt : "",
             isAddEditMemberPathoShowing : false,

             dataToChild_AddEditMemberPatho : {},
             mode_AddEditMemberPatho : 0 , //  0 -> new insert mode , 1 -> edit mode  
                                           //  and set 0 to default
        }
    }
}
</script>